import React from "react";

function Canvas_Compositing() {
  return (
    <div>
      <h1>Canvas_Compositing Component</h1>
      <p>This is the Canvas Compositing tutorial page content.</p>
    </div>
  );
}

export default Canvas_Compositing;
